<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
* { box-sizing: border-box; }
body { margin: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; background: #f5f5f5; }

/* Prevent mobile browser zoom on input focus (triggers when font-size < 16px) */
@media (max-width: 768px) {
  input, select, textarea,
  .el-input__inner,
  .el-textarea__inner {
    font-size: 16px !important;
  }
}
</style>
